// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__26SJD","newExpiryDate":"styles_newExpiryDate__1aYdH","footer":"styles_footer__qD7RY"};